import type { JSX } from 'react';

interface WebhooksPartialListNoticeProps {
  pagination: { total: number } | undefined;
  totalShown: number;
}

const WebhooksPartialListNotice = ({ pagination, totalShown }: WebhooksPartialListNoticeProps): JSX.Element => {
  return (
    <output className="m-0 mt-2 block text-sm text-warning font-body">
      Se muestran {totalShown} de {pagination?.total ?? '—'} webhooks. Aumenta el límite de consulta si necesitas ver el
      listado completo.
    </output>
  );
};

export default WebhooksPartialListNotice;
